import type { NamespaceSearchRequest } from '@unifyapps/network/generated/models/namespaceSearchRequest';
import { LocaleEnum } from '../const';
import { getLocaleBasedOnLanguage } from './getLocaleBasedOnLanguage';

const PLATFORM_SUPPORTED_LOCALES = new Set<string>([
  LocaleEnum.Arabic,
  LocaleEnum.Dutch,
  LocaleEnum.English,
  LocaleEnum.French,
  LocaleEnum.German,
  LocaleEnum.Italian,
  LocaleEnum.Spanish,
]);

export const getPlatformInterfaceNamespaceSearchRequest = (
  lng: string,
  ns: string,
): NamespaceSearchRequest => {
  let locale = lng;

  if (!PLATFORM_SUPPORTED_LOCALES.has(lng)) {
    const localeBasedOnLanguage = getLocaleBasedOnLanguage(lng, PLATFORM_SUPPORTED_LOCALES);

    if (localeBasedOnLanguage) {
      locale = localeBasedOnLanguage;
    }
  }

  return {
    interfaceIds: ['ua-platform'],
    componentIds: [`__ua_${ns}`],
    locale,
    // Ideally, for given interfaceId, locale and interfaceComponentId, there should be only one record
    page: { limit: 100, offset: 0 },
  };
};

// These are the namespace's currently supported via e_i18n_namespace i18n method.
// Maintaining this list because we don't want to try fetching e_i18n_namespace for unsupported ns's, as this call will be blocking on server
const SUPPORTED_PLATFORM_INTERFACE_NS = new Set(['ai-agents']);
const EMPTY_ARRAY = [];
export const getPlatformInterfaceNsArray = (ns: string | string[] | undefined) => {
  if (!ns) {
    return EMPTY_ARRAY;
  }

  const nsArray = (Array.isArray(ns) ? ns : [ns]).filter(Boolean);
  return nsArray.filter((item) => SUPPORTED_PLATFORM_INTERFACE_NS.has(item));
};
